import * as React from 'react';

import {colors} from '../colors/colors';

import styles from './feature-usage-box.module.css';

type Props = {
    currentUsage: number;
    maxUsage: number | null | undefined;
    hasCustomLimit: boolean;
    isCurrentPlan: boolean;
};

export function FeatureUsageBox(props: Props) {
    let currentUsagePercent;
    let maxUsagePercent;

    if (props.currentUsage === 0 && typeof props.maxUsage !== 'number') {
        currentUsagePercent = 0;
        maxUsagePercent = 1;
    } else if (typeof props.maxUsage !== 'number') {
        // Arbitrarily putting the current, limited usage at 25% of "unlimited" for visual clarity
        currentUsagePercent = 0.25;
        maxUsagePercent = 1;
    } else if (props.currentUsage === 0 && props.maxUsage === 0) {
        currentUsagePercent = 0;
        maxUsagePercent = 0;
    } else if (props.currentUsage === 0 && props.maxUsage !== 0) {
        currentUsagePercent = 0;
        maxUsagePercent = 1;
    } else if (props.currentUsage !== 0 && props.maxUsage === 0) {
        currentUsagePercent = 1;
        maxUsagePercent = 0;
    } else if (props.currentUsage > props.maxUsage) {
        currentUsagePercent = 1;
        maxUsagePercent = props.maxUsage / props.currentUsage;
    } else {
        currentUsagePercent = props.currentUsage / props.maxUsage;
        maxUsagePercent = 1;
    }

    return (
        <div
            className={
                props.isCurrentPlan
                    ? styles['feature-usage-box']
                    : styles['feature-usage-box--next-plan']
            }
        >
            <div className={styles['usage-bars']}>
                <Bar
                    fill={colors.blue}
                    total={props.currentUsage}
                    percent={currentUsagePercent}
                    text='Used so far'
                />
                <Bar
                    fill={props.isCurrentPlan ? colors.orange : colors.upgrade}
                    total={typeof props.maxUsage === 'number' ? props.maxUsage : 'unlimited'}
                    percent={maxUsagePercent}
                    text={decidePlanTextBasedOnCustomLimitAndUpgrade(
                        props.isCurrentPlan,
                        props.hasCustomLimit
                    )}
                />
            </div>
        </div>
    );
}

function decidePlanTextBasedOnCustomLimitAndUpgrade(
    isCurrentPlan: boolean,
    hasCustomLimit: boolean
) {
    if (isCurrentPlan !== null) {
        if (isCurrentPlan) {
            return hasCustomLimit ? 'Custom limit' : 'Plan limit';
        }
    }

    return 'With upgrade';
}

type BarProps = {
    fill: string;
    text: string;
    total: number | string;
    percent: number;
};

function Bar(props: BarProps) {
    return (
        <div className={styles['bar-container']}>
            {props.total}
            <div
                style={{backgroundColor: props.fill, height: `${props.percent * 100}%`}}
                className={styles.bar}
            />
            <div className={styles.subtext}>{props.text}</div>
        </div>
    );
}
